module.exports = __webpack_public_path__ + "img/babel-logo.e75db399.svg";